/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guardrails_Section_1_P2Inputs */



/**
* | output |
* | --- |
* | "This feature serves as a SUPPORTING TOOL for content filtering and operates exclusively based on the rules you configure." |
*
* @param {Guardrails_Section_1_P2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const guardrails_section_1_p2 = /** @type {((inputs?: Guardrails_Section_1_P2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guardrails_Section_1_P2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Funktion dient als UNTERSTÜTZENDES WERKZEUG zur Content-Filterung und arbeitet ausschließlich auf Basis der von Ihnen konfigurierten Regeln.")
	return /** @type {LocalizedString} */ ("This feature serves as a SUPPORTING TOOL for content filtering and operates exclusively based on the rules you configure.")
});